import {
  axios_nomination,
} from '@/plugins/axios';
import configuration from '@/configurations';

class ExportRepository {

  /**
   * @param {Number} export_id
   *
   * @returns {Promise}
   */
  async getDownloadLink(export_id) {
    const result = await axios_nomination.get(`${configuration.api_host}/v1/exports/${export_id}/download`);

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async searchExports(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/exports`,
      {
        params: input,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createExportIndividualFollowUp(input) {
    const result = await axios_nomination.post(`${configuration.api_host}/v1/exports/individual`, input);

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createExportTeam(input) {
    const result = await axios_nomination.post(`${configuration.api_host}/v1/exports/team`, input);

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createExportProspectingLists(input) {
    const result = await axios_nomination.post(`${configuration.api_host}/v1/exports/prospecting-lists`, input);

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createExportLicenses(input) {
    const result = await axios_nomination.post(`${configuration.api_host}/v1/exports/subscription`, input);

    return result.data;
  }
}

const export_repository = new ExportRepository();

export {
  export_repository,
};
